import React, { useState, useEffect } from 'react'
import './IssueReport.scss'
import { useParams } from 'react-router-dom';
import { Button, Table, Form, FormControl, Modal, Badge } from 'react-bootstrap';

import { serverUrl, fetchLandlordIds } from "../../../serverUrl";
import { toast } from 'react-toastify';


function ApartmentIssueReport() {
    const { id } = useParams();
    const isAllProperties = id === 'all';

    const [houseSelected, setHouseSelected] = useState([])
    const [houseSelectedIssues, setHouseSelectedIssues] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [statusUpdatingId, setStatusUpdatingId] = useState(null);

    const [showIssueModal, setShowIssueModal] = useState(false);
    const [selectedIssue, setSelectedIssue] = useState(null);

    const accessToken = localStorage.getItem("authTokens");
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;

    const config = {
        headers: { Authorization: `Bearer ${access}` }
    }

    const fetchIssues = async () => {
        const landlordIdValue = isAllProperties ? await fetchLandlordIds() : null;
        const reportParam = isAllProperties ? `landlord_id=${landlordIdValue}` : `apartment_id=${id}`;
        const issueResponse = await serverUrl.get(`/tenant/apartment-tenant-issues/?${reportParam}`, config);
        setHouseSelectedIssues(issueResponse?.data?.results || []);
    };

    useEffect(() => {
        const loadIssues = async () => {
            setIsLoading(true)
            try {
                if (isAllProperties) {
                    setHouseSelected({
                        id: null,
                        name: 'All Properties',
                        house_number: 'All Properties'
                    });
                } else {
                    const apartmentResponse = await serverUrl.get(`/landlord/apartment/${id}/`, config);
                    setHouseSelected(apartmentResponse.data);
                }

                await fetchIssues();
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false)
            }
        };

        loadIssues();
    }, [id]);

    const selectedUnit = houseSelected
    const idHouse = isAllProperties ? null : parseInt(id, 10)

    const handleOpenIssueModal = (issue) => {
        setSelectedIssue(issue);
        setShowIssueModal(true);
    };

    const handleCloseIssueModal = () => {
        setShowIssueModal(false);
        setSelectedIssue(null);
    };

    const handleUpdateIssueStatus = async (issueId, nextStatus) => {
        setStatusUpdatingId(issueId);
        try {
            await serverUrl.patch(`/tenant/issue-status/${issueId}/`, { status: nextStatus }, config);
            setHouseSelectedIssues((prevIssues) =>
                prevIssues.map((issue) =>
                    issue.id === issueId
                        ? { ...issue, status: nextStatus, status_label: nextStatus ? "open" : "resolved" }
                        : issue
                )
            );
            setSelectedIssue((prev) => (
                prev && prev.id === issueId
                    ? { ...prev, status: nextStatus, status_label: nextStatus ? "open" : "resolved" }
                    : prev
            ));
            toast.success(`Issue marked as ${nextStatus ? "open" : "resolved"}.`);
        } catch (error) {
            console.log(error);
            toast.error("Failed to update issue status.");
        } finally {
            setStatusUpdatingId(null);
        }
    };

    const [sortType, setSortType] = useState("created_at");
    const [sortOrder, setSortOrder] = useState("desc");
    const [searchQuery, setSearchQuery] = useState("");

    const handleSort = (sortField) => {
        setSortType(sortField);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const sortedData = [...houseSelectedIssues].sort((a, b) => {
        const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
        const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];
        if (sortOrder === "asc") {
            return sortValueA > sortValueB ? 1 : -1;
        }
        return sortValueA < sortValueB ? 1 : -1;
    });

    const filteredData = sortedData.filter((item) => {
        const searchableFields = `${item.tenant || ''} ${item.apartment_name || ''} ${item.description || ''} ${item.category || ''} ${item.status_label || ''}`.toLowerCase();
        return searchableFields.includes(searchQuery.toLowerCase());
    });

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = currentPage === totalPages - 1 ? filteredData.length : startIndex + itemsPerPage;
    const displayedItems = filteredData.slice(startIndex, endIndex);

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };

    if (isLoading) {
        return (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        );
    }

    return (
        <>
            {isAllProperties || selectedUnit.id === idHouse ?
                <div className='overflowReport'>
                    <div className='tasks'>
                        <h2>Tenants Feedback- {selectedUnit.name}</h2>

                        <div className='d-flex justify-content-between'>
                            <Form className="searchBar">
                                <FormControl type="text" placeholder="Search" onChange={handleSearch} />
                            </Form>
                        </div>
                        <Table className='table mt-2'>
                            <thead className="">
                                <th onClick={() => handleSort('tenant')}>Name</th>
                                <th onClick={() => handleSort('apartment_name')}>Apartment</th>
                                <th onClick={() => handleSort('description')}>Description</th>
                                <th onClick={() => handleSort('category')}>Issue Type</th>
                                <th onClick={() => handleSort('status')}>Status</th>
                                <th>Images</th>
                                <th onClick={() => handleSort('created_at')}>Date</th>
                                <th>Actions</th>
                            </thead>
                            <tbody>
                                {displayedItems.length === 0 && (
                                    <tr>
                                        <td colSpan={8} className="text-center">No issues found.</td>
                                    </tr>
                                )}
                                {displayedItems.map((issue) => (
                                    <tr key={issue.id}>
                                        <td>{issue.tenant}</td>
                                        <td>{issue.apartment_name || '-'}</td>
                                        <td>{issue.description}</td>
                                        <td className='text-capitalize'>{issue.category}</td>
                                        <td>
                                            <Badge bg={issue.status ? "warning" : "success"} text={issue.status ? "dark" : "light"}>
                                                {issue.status ? "Open" : "Resolved"}
                                            </Badge>
                                        </td>
                                        <td>{issue.images_count || 0}</td>
                                        <td>{new Date(issue.created_at).toLocaleDateString('en-US')}</td>
                                        <td className='d-flex gap-2'>
                                            <Button
                                                size="sm"
                                                variant="outline-primary"
                                                onClick={() => handleOpenIssueModal(issue)}
                                            >
                                                View
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant={issue.status ? "outline-success" : "outline-warning"}
                                                disabled={statusUpdatingId === issue.id}
                                                onClick={() => handleUpdateIssueStatus(issue.id, !issue.status)}
                                            >
                                                {statusUpdatingId === issue.id ? "Updating..." : issue.status ? "Resolve" : "Reopen"}
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="pagination">
                            <button onClick={handlePrevPage} disabled={currentPage === 0}>
                                &lt;
                            </button>
                            <span>{`${filteredData.length === 0 ? 0 : startIndex + 1}-${endIndex} of ${houseSelectedIssues.length}`}</span>
                            <button onClick={handleNextPage} disabled={currentPage === totalPages - 1 || totalPages === 0}>
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>
                :
                <></>
            }

            <Modal show={showIssueModal} onHide={handleCloseIssueModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Tenant Feedback Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedIssue && (
                        <>
                            <p><b>Tenant:</b> {selectedIssue.tenant}</p>
                            <p><b>Apartment:</b> {selectedIssue.apartment_name || "-"}</p>
                            <p><b>House:</b> {selectedIssue.house || "-"}</p>
                            <p><b>Category:</b> <span className='text-capitalize'>{selectedIssue.category}</span></p>
                            <p><b>Status:</b> {selectedIssue.status ? "Open" : "Resolved"}</p>
                            <p><b>Description:</b> {selectedIssue.description}</p>

                            <div className='issue-images-grid'>
                                {(selectedIssue.images || []).length > 0 ? (
                                    (selectedIssue.images || []).map((imageUrl, index) => (
                                        <a href={imageUrl} target="_blank" rel="noreferrer" key={`${selectedIssue.id}-${index}`}>
                                            <img src={imageUrl} alt={`Issue ${selectedIssue.id} attachment ${index + 1}`} className='issue-image-item' />
                                        </a>
                                    ))
                                ) : (
                                    <p className="text-muted">No images attached for this issue.</p>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {selectedIssue && (
                        <Button
                            variant={selectedIssue.status ? "success" : "warning"}
                            disabled={statusUpdatingId === selectedIssue.id}
                            onClick={() => handleUpdateIssueStatus(selectedIssue.id, !selectedIssue.status)}
                        >
                            {statusUpdatingId === selectedIssue.id
                                ? "Updating..."
                                : selectedIssue.status ? "Mark As Resolved" : "Reopen Issue"}
                        </Button>
                    )}
                    <Button variant="secondary" onClick={handleCloseIssueModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ApartmentIssueReport
